import { ExternalBillingClaimStatus } from "@/Common/Api/ExternalBilling/Dto/ExternalBillingClaimStatus";
import { PopulationBasedFundingEventWithNotesModel } from "@/Common/Models/PopulationBasedFunding/PopulationBasedFundingEventWithNotesModel";

class PatientPopulationBasedFundingModel {
    public history: PopulationBasedFundingEventWithNotesModel[];
    public extendedEventIds: string[] | null = null;

    public constructor(init?: Partial<PatientPopulationBasedFundingModel>) {
        Object.assign(this, init);

        if (!!init.history) {
            this.history = init.history.map(item => new PopulationBasedFundingEventWithNotesModel(item));
        }
    }

    public getIsPatientRegistered(): boolean {
        return this.getLatestNonRefusedEvent()?.isRegistered ?? false;
    }

    public getPatientHasPendingProposal(): boolean {
        return this.getLatestNonRefusedEvent()?.isPendingProposal ?? false;
    }

    public getSortedHistory(): PopulationBasedFundingEventWithNotesModel[] {
        return this.history?.sortByPropertyDesc(pbfEvent => pbfEvent.CreatedDate) ?? [];
    }

    private getLatestNonRefusedEvent(): PopulationBasedFundingEventWithNotesModel {
        return this.history
            ?.filter(pbfEvent =>
                pbfEvent.ClaimStatus !== ExternalBillingClaimStatus.Refused
                && pbfEvent.ClaimStatus !== ExternalBillingClaimStatus.Rejected
            )
            .sortByPropertyDesc(pbfEvent => pbfEvent.CreatedDate)
            ?.firstOrDefault();
    }
}

export { PatientPopulationBasedFundingModel };
